// 登录页面路由
export const LoginConfig = '/login';

// 不记录路由以作登录成功回调
export const UnRecordTrajectoryConfig = [
  '/login',
  '/login/register', // 0：绑定微信；1：用户注册；2：忘记密码
  '/login/password'
];

// 报错提示页面路由
export const ErrorConfig = '/error';

// 登记与团约页面路由
export const PhysicalLeaderConfig = [];

// 无需功能框架路由
export const UnFrameConfig = [
  '/appointment/schedule'
];
